export default __webpack_public_path__ + "static/11-bc3a775be199f96bbafff6e817c86a77.jpg";